export default () => {
  const init = () => {
    customElements.define("contact-form", ContactForm);
  };
  init();
};

class ContactForm extends HTMLElement{
  constructor() {
    super();
    this.handleDropdownItemClick = this.handleDropdownItemClick.bind(this);
    this.handleKeypress = this.handleKeypress.bind(this);
    this.translations = window.SS.Strings.contactErrorsMessage;
  }
  
  connectedCallback(){
    this.initElements();
    this.setEventListeners();
  }

  disconnectedCallback() {
    this.emailInput.removeEventListener('input', this.validateFields);
    this.firstNameInput.removeEventListener('input', this.validateFields);
    this.lastNameInput.removeEventListener('input', this.validateFields);
    this.addressInput.removeEventListener('input', this.validateFields);
    this.cityInput.removeEventListener('input', this.validateFields);
    this.zipInput.removeEventListener('input', this.validateFields);
    this.countryInput.removeEventListener('input', this.validateFields);
    this.phoneInput.removeEventListener('input', this.validateFields);
    this.bodyInput.removeEventListener('input', this.validateFields);
  }

  initElements(){
    this.emailInput = this.querySelector('#ContactForm-email') || null;
    this.firstNameInput = this.querySelector('#ContactForm-first-name') || null;
    this.lastNameInput = this.querySelector('#ContactForm-last-name') || null;
    this.addressInput = this.querySelector('#ContactForm-address') || null; 
    this.cityInput = this.querySelector('#ContactForm-city') || null; 
    this.zipInput = this.querySelector('#ContactForm-zip') || null;
    this.countryInput = this.querySelector('#ContactForm-country') || null; 
    this.phoneInput = this.querySelector('#ContactForm-phone') || null; 
    this.emailError = this.querySelector('#emailError') || null;
    this.lastNameError = this.querySelector('#lastNameError') || null;
    this.firstNameError = this.querySelector('#firstNameError') || null;
    this.addressError = this.querySelector('#addressError') || null;
    this.cityError = this.querySelector('#cityError') || null;
    this.zipError = this.querySelector('#zipError') || null;
    this.countryError = this.querySelector('#countryError') || null;
    this.phoneError = this.querySelector('#phoneError') || null;
    this.dropdown = this.querySelector('.request-type .dropdown');
    this.dropdownTitle = this.dropdown.querySelector('.dropdown__title');
    this.dropdownMenu = this.dropdown.querySelector('.dropdown-menu');
    this.dropdownItems = this.dropdown.querySelectorAll('.dropdown-menu li');
  }

  setEventListeners() {
    this.emailInput.addEventListener('input', () => this.validateInput(this.emailInput, this.emailError, this.translations.emailError));
    this.firstNameInput.addEventListener('input', () => this.validateInput(this.firstNameInput, this.firstNameError, this.translations.firstNameError));
    this.lastNameInput.addEventListener('input', () => this.validateInput(this.lastNameInput, this.lastNameError, this.translations.lastNameError));
    this.addressInput.addEventListener('input', () => this.validateInput(this.addressInput, this.addressError, this.translations.addressError));
    this.cityInput.addEventListener('input', () => this.validateInput(this.cityInput, this.cityError, this.translations.cityError));
    this.zipInput.addEventListener('input', () => this.validateInput(this.zipInput, this.zipError, this.translations.zipError));
    this.countryInput.addEventListener('input', () => this.validateInput(this.countryInput, this.countryError, this.translations.countryError));
    this.phoneInput.addEventListener('input', () => this.validatePhoneInput(this.phoneInput, this.phoneError, this.translations.phoneError));
    this.phoneInput.addEventListener('keypress', (e) => this.handleKeypress(e));
    this.dropdownItems.forEach(item => {
      item.addEventListener('click', () => this.handleDropdownItemClick(item));
    });
  }

  handleKeypress(e){
    const charCode = (e.which) ? e.which : e.keyCode;
    if (charCode !== 43 && (charCode < 48 || charCode > 57)) {
      e.preventDefault();
      return false;
    }
    return true;
  }

  handleDropdownItemClick(item){
    const arrowElement = this.dropdownTitle.querySelector('.dropdown__arrow');
    this.dropdownTitle.textContent = item.textContent;
    const subject=document.getElementById('subject')
    subject.value = item.textContent;
    if (subject.value.length > 0) {
      setTimeout(()=> {
        const subField= document.querySelector('.subject__field-icon');
        subField.style.top='0';
      })
    }

    if (arrowElement) {
      this.dropdownTitle.appendChild(arrowElement);
    }
    this.dropdownItems.forEach(i => i.classList.remove('active'));
    item.classList.add('active');
    this.dropdownTitle.classList.remove('inactive');
    this.dropdown.classList.toggle('open');
    this.dropdownTitle.setAttribute('aria-expanded', this.dropdown.classList.contains('open') ? 'false' : 'true');
  }

  validatePhoneInput(inputElement, errorElement, errorMessage) {
    const value = inputElement.value.trim();
    const phoneRegex = /^[+]?[0-9\s-()]+$/;
    const isValid = phoneRegex.test(value) && value.length >= 7;
    const elementError = errorElement;
    let errorElementText = '';
  
    if (!isValid) {
      errorElementText = errorMessage;
      inputElement.classList.add('error-message');
    } else {
      inputElement.classList.remove('error-message');
    }
  
    elementError.textContent = errorElementText;
    return isValid;
  }

  validateInput(inputElement, errorElement, errorMessage) {
    const value = inputElement.value.trim();
    const isValid = value.length > 0;
    const elementError = errorElement;
    let errorElementText = '';

    if (!isValid) {
      errorElementText = errorMessage;
      inputElement.classList.add('error-message');
    } else {
      inputElement.classList.remove('error-message');
    }

    elementError.textContent = errorElementText;
    return isValid;
  }
};
